import { CreditEngineRepository } from './CreditEngineRepository'
import creditEngineRepository from './CreditEngineRepository'

const resource = '/perfios';
export default {
  initiatePerfios(perfiosInitiateRequest) {

    creditEngineRepository.setContentType("application/json")
    return CreditEngineRepository.post(`${resource}`, perfiosInitiateRequest);
  }
}